import { environment } from '../../environments/environment';
import { EnvironmentDetailsService } from '../services/environment-details.service';
import { HttpHeaders } from '@angular/common/http';
import { COMMON_CONSTANTS, ENTITLEMENT_ACTIVITYNAMES, MANAGE_LINE_CONST, RATEPLANSERVICE } from '../common/core/common.constants';
import { Injectable } from '@angular/core';
import { isNullOrUndefined } from 'src/app/services/utils';
import { AuthHttpService } from '../../app/services/http-wrapper.service';
import { HttpCacheService } from '../../app/services/http-cache.service';
import * as _ from 'lodash';
import { HelperUtilityService } from './helper-utility.service';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ChangeServiceService {
  public changeServiceUrl: any;
  public authToken: any;
  public orgID: any;
  public submitResponse: any;
  public serviceAgreementUrl: any;
  public subscriberUrl: any;
  public TermsUrl: any;
  private ban: string;
  private authInfo: any;
  public currentServicesTotal = 0;
  public previousServicesTotal = 0;
  public postAddServices = [];
  public postUnchangedServices = [];
  public postRemoveServices = [];
  public initialServicesList = [];
  public subscriberData = [];
  public serviceSelectionChanged = new BehaviorSubject(false);
  public triggerPromoApi = new BehaviorSubject(false);
  public userFullName : string;

  constructor(
    private _http: AuthHttpService,
    private _cacheSvc: HttpCacheService,
    private _helperUtilSvc: HelperUtilityService,
    private _envSvc: EnvironmentDetailsService) {
    this.authToken = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY)) ?
      COMMON_CONSTANTS.HEADER_PROPERTIES.BEARER_KEY + this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY) : '';
    this.orgID = this._helperUtilSvc.getOrgID();
  }

  evaluatePromotion(requestbody){
    let httpOptions = this.setHeadersForEvaluatePromo();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this._http.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_EVALUATE_PROMOTION);
    } else {
      const evaluatePromo = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_EVALUATE_PROMOTION;
      return this._http.post(evaluatePromo, requestbody, httpOptions);
    }
  }
  setHeadersForEvaluatePromo(){
    this.authToken = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY)) ?
      COMMON_CONSTANTS.HEADER_PROPERTIES.BEARER_KEY + this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY) : '';
    return {
      headers: new HttpHeaders(
        {
          'Accept': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Content-Type': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Cache-Control': COMMON_CONSTANTS.HEADER_PROPERTIES.NO_CACHE,
          'B2b-Client': COMMON_CONSTANTS.HEADER_PROPERTIES.B2B_CLIENT_ID_TFB_AM_APP,
          'B2b-Org': this._helperUtilSvc.getOrgID(),
          'transactionID': this._helperUtilSvc.getTransactionID(),
          'authToken':this._helperUtilSvc.getAuthToken(),
        }
      )
    };
  }

  getChangeServiceDetails() {
    const httpOptions = environment.ENABLE_SPECTRUM? this.setHeadersForRatePlanandservicesAPiCall():this.setHeaders();
    const servicesURL = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_CHANGE_SERVICE;
    let linesubtype = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.SELECTED_LINE_SUBTYPE);
    let linesubtypeArr = [MANAGE_LINE_CONST.SUBLINETYPE_ML, MANAGE_LINE_CONST.SUBLINETYPE_PTT];
    const requestBody = {
      'mobileNumber': sessionStorage.getItem(COMMON_CONSTANTS.CHANGE_SERVICE_MSISDN),
      ...(environment.ENABLE_ML_PTT_FEATURE && linesubtypeArr.includes(linesubtype)) && {"device": MANAGE_LINE_CONST.ML_PTT_DEVICE_ID_SERV},
    };
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this._http.get(servicesURL);
    } else {
      return this._http.post(servicesURL, requestBody, httpOptions);
    }
  }


  getServiceAgreement(ratePlansDetailsList, transactionType?: any) {
    const body = this.setServiceAgreementParams(ratePlansDetailsList,transactionType);
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this._http.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SERVICE_AGREEMENT);
    } else {
    return this._http.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SERVICE_AGREEMENT, body, httpOptions);
    }
  }

  getSubscriberDetails() {
    const httpOptions = this.setHeaders();
    if (environment.mocked_all || environment.mocked_endpoints) {
      return this._http.get(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUBSCRIBER_DETAILS);
    } else {
      const requestBody = {
        'org': this._helperUtilSvc.getOrgID(),
        'mobileNumber': sessionStorage.getItem(COMMON_CONSTANTS.CHANGE_SERVICE_MSISDN),
        'filter': 'subscriber'
      }
      return this._http.post(this._envSvc.APIGEE_TOKEN_URLS.APIGEE_SUBSCRIBER_DETAILS, requestBody, httpOptions);
    }
  }


  setHeaders() {
    this.authToken = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY)) ?
      COMMON_CONSTANTS.HEADER_PROPERTIES.BEARER_KEY + this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY) : '';
    return {
      headers: new HttpHeaders(
        {
          'Accept': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Content-Type': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Cache-Control': COMMON_CONSTANTS.HEADER_PROPERTIES.NO_CACHE,
          // 'Authorization': this.authToken,
          'B2b-Client': this._helperUtilSvc.getClientId(),
          'B2b-Org': this._helperUtilSvc.getOrgID(),
          'authType': this._helperUtilSvc.getAuthType(),
          'transactionID': this._helperUtilSvc.getTransactionID(),
          'authToken':this._helperUtilSvc.getAuthToken(),
        }
      )
    };
  }

  setHeadersForRatePlanandservicesAPiCall() {
    this.authToken = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY)) ?
      COMMON_CONSTANTS.HEADER_PROPERTIES.BEARER_KEY + this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY) : '';
      const olmOrgId = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.IS_OLM_ORG);
    return {
      headers: new HttpHeaders(
        {
          'Accept': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Content-Type': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Cache-Control': COMMON_CONSTANTS.HEADER_PROPERTIES.NO_CACHE,
          // 'Authorization': this.authToken,
          'B2b-Client': this._helperUtilSvc.getClientId(),
          'B2b-org': !isNullOrUndefined(olmOrgId) ? olmOrgId : this._helperUtilSvc.getOrgID(),
          'authType': this._helperUtilSvc.getAuthType(),
          'transactionID': this._helperUtilSvc.getTransactionID(),
          'authToken':this._helperUtilSvc.getAuthToken(),
        }
      )
    };
  }

  submitServices(addedServices: any, removedServices: any) {
    const httpOptions = this.setHeaders();
    const servicesURL = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_CHANGESERVICES_SUBMIT;

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this._http.get(servicesURL);
    } else {
      const body = this.setSubmitChangesParams(addedServices, removedServices);
      return this._http.post(servicesURL, body, httpOptions);
    }
  }

  /*
    - Takes in MSISDN and passes BAN from session storage to call /partner-subscriptions API
    - Fetches subscription details (Eligibility Status, Registration Status, Redirtection Link) for NETFLIX Promotion
  */
  getPartnerRedirectionLink(msisdn, redemptionSocs?) { 
    const httpOptions = this.setHeaders();
    const servicesURL = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_PARTNER_SUBSCRIPTION_REDIRECTION;
    let partnerName = this.setPartnerName(redemptionSocs)

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this._http.get(servicesURL);
    } else {
      const ban = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY);
      const requestBody = {
        "ban": ban,
        "msisdn": msisdn,
        "partnerName": partnerName
      }
      return this._http.post(servicesURL, requestBody, httpOptions);
    }
  }
  setPartnerName(redemptionSocs): string {
    if(redemptionSocs?.isNetFlixSoc || redemptionSocs?.isActiveNFX) {
      return COMMON_CONSTANTS.NETFLIX_CAPS_TXT;
    } 
    if(redemptionSocs?.isHuluSoc || redemptionSocs?.isActiveHULU) {
      return COMMON_CONSTANTS.HULU_CAPS_TXT;
    }
  }

  getPlanChangeEffectiveDate(body: any) {
    const httpOptions = this.setHeaders();
    const url = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_PLAN_CHANGE_EFFECTIVE_DATE;

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this._http.get(url);
    } else {
      return this._http.post(url, body, httpOptions);
    }
  }

  private setServiceAgreementParams(ratePlansDetailsList: any,transactionType?: any) {
    let isPTTSoc:boolean = false;
    if(environment.ENABLE_ML_PTT_FEATURE ){
      let isPlanChanged = false;
      if(transactionType == ENTITLEMENT_ACTIVITYNAMES.CHANGE_RATE_PLAN && sessionStorage.getItem(RATEPLANSERVICE.IS_PLAN_CHANGE)=="true"){
        isPlanChanged = true;
      }
      let addedServicesList = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.ADDED_SERVICES))?.filter(item => {
          return (!item?.current || !item?.currentService) && item?.subLineType === MANAGE_LINE_CONST.SUBLINETYPE_PTT;
      });
      if(!isPlanChanged && addedServicesList?.length>0) {
        isPTTSoc = true;
      }
    }
    const msisdn = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.CHANGE_SERVICE_MSISDN);
    this.ban = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY);
    this.authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA));
    this.currentServicesTotal = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.CURRENT_SERVICES_TOTAL));
    this.previousServicesTotal = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.PREVIOUS_SERVICES_TOTAL));
    const subsidyPlanIndicatorValue = JSON.parse(!isNullOrUndefined(sessionStorage.getItem(RATEPLANSERVICE.ADDEDPLANS)) ? sessionStorage.getItem(RATEPLANSERVICE.ADDEDPLANS) : '{}');
    this.userFullName = this.authInfo.firstName + " " + this.authInfo.lastName;
    return {
      ban: this.ban,
      ...subsidyPlanIndicatorValue[0]?.subsidyPlanIndicator && {subsidyPlanIndicator: subsidyPlanIndicatorValue[0].subsidyPlanIndicator},
      includesPTTaddon: isPTTSoc,
      documentReturnType: COMMON_CONSTANTS.HTML,
      transactionId: '',
      transactionType: COMMON_CONSTANTS.SERVICE_LEVEL.RATE_PLAN_CHANGE,
      customerDetails: {
        fullName: this.userFullName,
        contactInformation: [
          {
            phoneNumber: '',
            email: this.authInfo.logonId,
          }
        ]
      },
      serviceAgreementDetails: [
        {
          msisdn: msisdn,
          sim: '',
          imei: '',
          serviceDetails: [
            {
              serviceName: '',
              changeEffectiveDate: '',
              mrc: '',
              serviceChargeType: 0
            }
          ],
          ratePlanDetails: ratePlansDetailsList
        }
      ],
      serviceAgreementChargeDetails: {
        regulatoryProgramFeeAmount: 0,
        totalActivationFee: 0,
        previousTotalMonthlyCharges: this.previousServicesTotal.toFixed(2),
        firstBillTotalMonthlyCharges: '',
        regularTotalMonthlyCharges: this.currentServicesTotal.toFixed(2),
        totalMonthlyChargesDiff: 0,
        totalAmountDue: 0,
        taxTreatment: 'TI',
        digitsIndicator: false
      }
    };
  }

  constructPostValueOject(service: any, socType?: string) {
    const postValueObj = {};
    postValueObj[COMMON_CONSTANTS.PACKAGE.SERVICE_CODE] = service.soc;
    if (!_.isEmpty(service.serviceSequenceNumber)) {
      postValueObj[COMMON_CONSTANTS.PACKAGE.SERVICE_SEQUENCE_NBR] = service.serviceSequenceNumber;
    } else {
      postValueObj[COMMON_CONSTANTS.PACKAGE.SERVICE_SEQUENCE_NBR] = '';
    }
    postValueObj[COMMON_CONSTANTS.PACKAGE.LEVEL] = !_.isEmpty(service.level) ? service.level : COMMON_CONSTANTS.SERVICE_LEVEL.SUBSCRIBER;
    postValueObj[COMMON_CONSTANTS.PACKAGE.EFFECTIVE_DATE_TYPE] = service?.effectiveToday===true ? 'T' : 'N' ;
    if(socType==COMMON_CONSTANTS.SERVICES.REMOVE_SERVICES)
    {
    postValueObj[COMMON_CONSTANTS.PACKAGE.EFFECTIVE_DATE] = service.effectiveDate;
    }
    return postValueObj;
  }

 constructPostValueOjectForRemove(service: any) {
    const postValueObj = {};
    postValueObj[COMMON_CONSTANTS.PACKAGE.SERVICE_CODE] = service.soc;
    if (!_.isEmpty(service.serviceSequenceNumber)) {
      postValueObj[COMMON_CONSTANTS.PACKAGE.SERVICE_SEQUENCE_NBR] = service.serviceSequenceNumber;
    } else {
      postValueObj[COMMON_CONSTANTS.PACKAGE.SERVICE_SEQUENCE_NBR] = '';
    }
    postValueObj[COMMON_CONSTANTS.PACKAGE.LEVEL] = !_.isEmpty(service.level) ? service.level : COMMON_CONSTANTS.SERVICE_LEVEL.SUBSCRIBER;
    postValueObj[COMMON_CONSTANTS.PACKAGE.EFFECTIVE_DATE_TYPE] = 'N';
    postValueObj[COMMON_CONSTANTS.PACKAGE.EFFECTIVE_DATE] = service.effectiveDate;
    return postValueObj;
  }

  constructServiceList(ratePlansAddedList: any, ratePlansRemovedList: any) {
    this.initialServicesList = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.INITIAL_SERVICES_LIST));
    _.each(ratePlansAddedList, (service) => {
      if (service.currentService === false) {
        this.postAddServices.push(this.constructPostValueOject(service));
      } else {
        this.postUnchangedServices.push(this.constructPostValueOject(service));
      }
    });
    _.each(ratePlansRemovedList, (service) => {
      this.postRemoveServices.push(this.constructPostValueOject(service,COMMON_CONSTANTS.SERVICES.REMOVE_SERVICES));
    });
  }

  setSubmitChangesParams(ratePlansAddedList: any, ratePlansRemovedList: any) {
    this.postAddServices = [];
    this.postRemoveServices = [];
    this.postUnchangedServices = [];
    this.constructServiceList(ratePlansAddedList, ratePlansRemovedList);
    this.subscriberData = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.SUBSCRIBER_DATA));
    this.currentServicesTotal = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.CURRENT_SERVICES_TOTAL));
    this.previousServicesTotal = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.PREVIOUS_SERVICES_TOTAL));
    const lastUpdateDate = _.get(this.subscriberData, 'account.lastUpdate.lastUpdateDate', '');
    const lastUpdateStamp = _.get(this.subscriberData, 'account.lastUpdate.lastUpdateStamp', '');
    const authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));

    return {
      mobileNumber: sessionStorage.getItem(COMMON_CONSTANTS.CHANGE_SERVICE_MSISDN),
      newTotalMrc: this.currentServicesTotal.toFixed(2),
      existingTotalMrc: this.previousServicesTotal.toFixed(2),
      lastUpdate: {
        lastUpdateDate: lastUpdateDate,
        lastUpdateStamp: lastUpdateStamp
      },
      addServices: this.postAddServices,
      removeServices: this.postRemoveServices,
      logonId: !isNullOrUndefined(authInfo) ? authInfo.logonID : COMMON_CONSTANTS.LOGON_ID,
      email: !isNullOrUndefined(authInfo) ? authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID
    };
  }

  getCatalogServicesByOrg(orgId) {
    const httpOptions = environment.ENABLE_SPECTRUM ? this.setHeadersForRatePlanandservicesAPiCall() : this.setHeaders();
    const servicesURL = this._envSvc.APIGEE_TOKEN_URLS.APIGEE_ORG_CATALOG_SERVICES;
    const requestBody = {
      'include-detail': true,
      'catalog-filter': 'services',
      'org': orgId
    };

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this._http.get(servicesURL);
    } else {
      return this._http.post(servicesURL, requestBody, httpOptions);
    }
  }

}
